import { Controller } from "@hotwired/stimulus";

// « Règles de calcul » in tabs (19/10/2026): one form, saved once.
// - remember: the main tab open goes with the form, and the page comes back on it after the save.
// - subtab: the scales have a tab each, switched here and not by ds-tabs, which
//   travels in the GO4LEARN bundle whose weight may not grow.
// - reveal: a field the browser refuses (a rate above 100…) opens its tab and
//   its sub-tab, instead of a save that silently does nothing.
export default class extends Controller {
  static targets = ["tab"];

  remember(event) {
    const tab = event.target.closest("[data-ds-tabs-target='tab']");
    if (tab && this.hasTabTarget) this.tabTarget.value = tab.dataset.tab;
  }

  subtab(event) {
    this.showSubtab(event.currentTarget.dataset.subtab, event.currentTarget.closest("[data-subtabs]"));
  }

  showSubtab(id, group) {
    group.querySelectorAll("[role='tab'][data-subtab]").forEach((tab) => {
      const on = tab.dataset.subtab === id;
      tab.setAttribute("aria-selected", String(on));
      tab.tabIndex = on ? 0 : -1;
    });
    group.querySelectorAll(".ds-subpanel").forEach((panel) => {
      panel.hidden = panel.dataset.subtab !== id;
    });
  }

  reveal(event) {
    const panel = event.target.closest(".ds-tabpanel");
    const tab = panel && document.getElementById(panel.getAttribute("aria-labelledby"));
    if (panel?.hidden && tab) tab.click();
    const subpanel = event.target.closest(".ds-subpanel");
    if (subpanel?.hidden) this.showSubtab(subpanel.dataset.subtab, subpanel.closest("[data-subtabs]"));
  }
}
